export default __webpack_public_path__ + "static/media/Chain.88028d88.png";